import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

export default component({
	name: 'Shape',
	props: {
		height: prop(String).default('initial'),
		width: prop(String).default('initial'),
	},
	mounted(): void {
		$(this.$el).shape()
	},
	methods: {
		/**
		 * 	Flips the shape over counter-clockwise.
		 */
		flipBack(): void {
			setTimeout(() => $(this.$el).shape('flip back'), 250)
		},
		/**
		 * 	Flips the shape left.
		 */
		flipLeft(): void {
			setTimeout(() => $(this.$el).shape('flip left'), 250)
		},
		/**
		 * 	Flips the shape over clock-wise.
		 */
		flipOver(): void {
			setTimeout(() => $(this.$el).shape('flip over'), 250)
		},
		/**
		 * 	Flips the shape right.
		 */
		flipRight(): void {
			setTimeout(() => $(this.$el).shape('flip right'), 250)
		},
		/**
		 * 	Flips the shape upward.
		 */
		flipUp(): void {
			setTimeout(() => $(this.$el).shape('flip up'), 250)
		},
	},
	render() {
		return (
			<div class="ui shape">
				<div class="sides">
					{this.$slots.default}
				</div>
			</div>
		)
	},
})
